import React, { useState } from 'react';
import { X, Clock, User, FileText, Calendar } from 'lucide-react';

const BookingModal = ({ isOpen, onClose, onSave, selectedDate, existingBooking }) => {
    const [formData, setFormData] = useState({
        title: existingBooking?.title || '',
        name: existingBooking?.extendedProps?.name || '',
        service: existingBooking?.extendedProps?.service || 'consultation',
        duration: existingBooking?.extendedProps?.duration || '30',
        notes: existingBooking?.extendedProps?.notes || '',
        date: selectedDate ? selectedDate.dateStr : '',
        time: selectedDate ? selectedDate.dateStr.split('T')[1]?.substring(0, 5) || '09:00' : '09:00'
    });

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({
            ...formData,
            id: existingBooking?.id || Date.now().toString(),
            start: `${formData.date}T${formData.time}`,
            end: calculateEndTime(formData.date, formData.time, formData.duration)
        });
    };

    const calculateEndTime = (date, time, duration) => {
        const startDate = new Date(`${date}T${time}`);
        const endDate = new Date(startDate.getTime() + parseInt(duration) * 60000);
        return endDate.toISOString();
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="glass-card w-full max-w-md p-6 m-4" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-poppins font-semibold text-white">
                        {existingBooking ? 'Edit Booking' : 'New Booking'}
                    </h2>
                    <button onClick={onClose} className="text-white/60 hover:text-white">
                        <X size={24} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm text-white/70 mb-1">Service Type</label>
                        <select
                            value={formData.service}
                            onChange={e => setFormData({ ...formData, service: e.target.value })}
                            className="w-full bg-white/5 border border-white/10 rounded-lg p-2.5 text-white focus:border-accent outline-none"
                        >
                            <option value="consultation">Initial Consultation</option>
                            <option value="followup">Follow-up Meeting</option>
                            <option value="development">Development Session</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm text-white/70 mb-1">Client Name</label>
                        <div className="relative">
                            <User size={18} className="absolute left-3 top-3 text-white/40" />
                            <input
                                type="text"
                                value={formData.name}
                                onChange={e => setFormData({ ...formData, name: e.target.value, title: `${e.target.value} - ${formData.service}` })}
                                className="w-full bg-white/5 border border-white/10 rounded-lg p-2.5 pl-10 text-white focus:border-accent outline-none"
                                placeholder="John Doe"
                                required
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm text-white/70 mb-1">Date</label>
                            <div className="relative">
                                <Calendar size={18} className="absolute left-3 top-3 text-white/40" />
                                <input
                                    type="date"
                                    value={formData.date}
                                    onChange={e => setFormData({ ...formData, date: e.target.value })}
                                    className="w-full bg-white/5 border border-white/10 rounded-lg p-2.5 pl-10 text-white focus:border-accent outline-none"
                                    required
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm text-white/70 mb-1">Time</label>
                            <div className="relative">
                                <Clock size={18} className="absolute left-3 top-3 text-white/40" />
                                <input
                                    type="time"
                                    value={formData.time}
                                    onChange={e => setFormData({ ...formData, time: e.target.value })}
                                    className="w-full bg-white/5 border border-white/10 rounded-lg p-2.5 pl-10 text-white focus:border-accent outline-none"
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm text-white/70 mb-1">Duration</label>
                        <select
                            value={formData.duration}
                            onChange={e => setFormData({ ...formData, duration: e.target.value })}
                            className="w-full bg-white/5 border border-white/10 rounded-lg p-2.5 text-white focus:border-accent outline-none"
                        >
                            <option value="15">15 minutes</option>
                            <option value="30">30 minutes</option>
                            <option value="45">45 minutes</option>
                            <option value="60">1 hour</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm text-white/70 mb-1">Notes</label>
                        <div className="relative">
                            <FileText size={18} className="absolute left-3 top-3 text-white/40" />
                            <textarea
                                value={formData.notes}
                                onChange={e => setFormData({ ...formData, notes: e.target.value })}
                                className="w-full bg-white/5 border border-white/10 rounded-lg p-2.5 pl-10 text-white focus:border-accent outline-none h-24 resize-none"
                                placeholder="Any special requirements..."
                            />
                        </div>
                    </div>

                    <button type="submit" className="btn-primary w-full mt-4">
                        {existingBooking ? 'Update Booking' : 'Confirm Booking'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default BookingModal;
